angular.module('app.reportes', [
  'ui.router',
  'toastr',
  'app.reportesService'
])

  .config(
    ['$stateProvider', '$urlRouterProvider',
      function ($stateProvider, $urlRouterProvider) {
        $stateProvider
          .state('index.reportes', {

            abstract: true,

            url: 'reportes',

            params: {

            },

            views: {
              '': {
                templateUrl: 'app/reportes/reportes.tpl.html',
                resolve: {
                },
                controller: ['$scope', '$state', 'toastr',
                  function ($scope, $state, toastr) {



                  }]
              }
            }

          })
          
          .state('index.reportes.list', {

            url: '',

            views: {
              '': {
                templateUrl: 'app/reportes/reportesDinamicos.list.tpl.html',
                resolve: {
                  /*permisoEstado: ['authService',
                    function (authService) {
                      return authService.loginPermission(33);
                    }],*/
                  // dataListadoReportes: ['reportesService',
                  //   function (reportesService) {
                  //     return reportesService.getListadoReportes();
                  //   }]
                },
                controller: ['$scope', '$state', 'toastr', 'reportesService', 'ngDialog', 'authService', 'utilsService', '$filter', 
                  function ($scope, $state, toastr, reportesService, ngDialog, authService, utilsService, $filter) {

                    CENTRO = authService.getLocalData('CENTRO');

                    ID_DESPACHO = $scope.CONSTANTES.REGISTRO_FALSO;
                    if ((CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_ASISTENTE) || (CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_MEDIADOR))
                    {
                      ID_DESPACHO = CENTRO.ID_DESPACHO;
                    }

                    $scope.reporte = {};
                    // $scope.dataListadoReportes = dataListadoReportes.data;

                    $scope.parametros = {};

                    $scope.selectedReporte = function () {
                      $scope.lista = [];
                      reportesService.getParametrosReporte($scope.reporte.ID_REPORTE)
                        .then(function (response) {
                          $scope.parametros = response.data;
                          
                          console.log('parametros',$scope.parametros);

                          // if ($scope.Parametros.length > 0) {
                          //   for (var i in $scope.Parametros) {

                          //     if ($scope.Parametros[i].ID_TIPO_DATO == $scope.constantes.TIPO_DATO_LISTA) {
                          //       $scope.asignarCatalogo($scope.Parametros[i].ID_REPORTE_PARAMETRO);

                          //     }
                          //   }
                          // }


                          angular.forEach($scope.parametros, function(value, key) 
                          {
                            if(value.ID_REPORTE_PARAMETRO_PADRE == value.ID_REPORTE_PARAMETRO)
                            {
                              var parametro=
                              {
                                ID_REPORTE_PARAMETRO:value.ID_REPORTE_PARAMETRO,
                                VALORES:[ID_DESPACHO]
                              }
                              reportesService.getCatalogoReporteDinamico(parametro)
                              .then(function (response) {
                                value.lista = response.data;

                              }, function (error) {
                                toastr.error(error);
                              });
                            }
                            
                          });
                          
                        }, function (error) {
                          toastr.error(error);
                        });
                    }

                    // $scope.asignarCatalogo = function (ID_REPORTE_PARAMETRO) {
                    //   reportesService.getCatalogoReporte(ID_REPORTE_PARAMETRO)
                    //     .then(function (response) {
                    //       $scope.lista[ID_REPORTE_PARAMETRO] = response.data;
                    //       console.log('mi lista', $scope.lista);
                    //     }, function (error) {
                    //       toastr.error(error);
                    //     });
                    // }


                    $scope.seleccion = function(x,id){
                      console.log('x ',x);
                      console.log('id ',id);
                      x.VALOR=id;
                      $scope.VALORES=[];
                      getPadres(x);
                      console.log('getPadres(x)',getPadres(x));
                      var parametro; 
                      console.log('$scope.parametros',$scope.parametros)
                      // for(var i of $scope.parametros) 
                      angular.forEach($scope.parametros, function(value, key) {
                        console.log(key + ': ' + value.TEXTO, value.VALOR);
                        console.log(value.ID_REPORTE_PARAMETRO_PADRE,x.ID_REPORTE_PARAMETRO);
                        if(value.ID_REPORTE_PARAMETRO_PADRE==x.ID_REPORTE_PARAMETRO){
                          var parametro={
                            ID_REPORTE_PARAMETRO:x.ID_REPORTE_PARAMETRO,
                            VALORES:[]
                          }
                            parametro.VALORES=$scope.VALORES;
                            console.log(parametro);
                            reportesService.getCatalogoReporteDinamico(parametro)
                        .then(function (response) {
                          
                          // $scope.lista[ID_REPORTE_PARAMETRO] = response.data;
                          // console.log('llamada',$scope.parametros[3]);
                          value.VALOR=null;
                          value.lista=response.data;

                        }, function (error) {
                          toastr.error(error);
                        });
                            // this.reporteService.getCatalogoReporteDinamico(parametro).(
                            //   data => {
                            //     element.VALOR=null;
                            //     element.lista=data;
                            // });
                        }

                      });
                          // (var i=0; i < $scope.parametros.length; i++)
                      
                      


                      
                      // this.vwReporteParametros.forEach(element => {
                        
                      // });
                    };
                  


                    /*for (var i=0; i < $scope.parametros.length; i++)
                    {console.log('$scope.parametros[i]',$scope.parametros[i]);
                      if($scope.parametros[i].ID_REPORTE_PARAMETRO_PADRE==x.ID_REPORTE_PARAMETRO){
                        var parametro={
                          ID_REPORTE_PARAMETRO:x.ID_REPORTE_PARAMETRO,
                          VALORES:[]
                        }
                          parametro.VALORES=$scope.VALORES;
                          reportesService.getCatalogoReporteDinamico(parametro)
                      .then(function (response) {
                        
                        // $scope.lista[ID_REPORTE_PARAMETRO] = response.data;
                        console.log('llamada',$scope.parametros[3]);
                        $scope.parametros[3].VALOR=null;
                        $scope.parametros[3].lista=response.data;

                      }, function (error) {
                        toastr.error(error);
                      });
                          // this.reporteService.getCatalogoReporteDinamico(parametro).(
                          //   data => {
                          //     element.VALOR=null;
                          //     element.lista=data;
                          // });
                      }


                    }*/



                    $scope.VALORES=[];
                    getPadres = function(x){
                      console.log('x',x);
                      if(x.ID_REPORTE_PARAMETRO_PADRE){
                        for (var i=0; i < $scope.parametros.length; i++){
                          if($scope.parametros[i].ID_REPORTE_PARAMETRO==x.ID_REPORTE_PARAMETRO_PADRE){
                              getPadres($scope.parametros[i]);
                              $scope.VALORES.push(x.VALOR);
                              break;
                          }
                        }
                      }else{
                        $scope.VALORES.push(x.VALOR);
                      }
                  
                    }




                    $scope.grabarParametrosPDF = function (isValid) {
                      // $scope.parametros.push({REPORTE_PARAMETRO:'P_USUARIO',VALOR:'EPOMBAL'});
                      console.log('parametros seleccionados',$scope.parametros);
                      if (isValid)
                      {
                        $scope.objetoReporte = {};
                        $scope.objetoReporte.PARAMETROS = $scope.parametros;
                        $scope.objetoReporte.ID_REPORTE = $scope.reporte.ID_REPORTE;
                        $scope.objetoReporte.ID_USUARIO_REGISTRO = authService.getIdUsuario(); 
                        // $scope.objetoReporte.USUARIO = 'EPOMBAL';
                        reportesService.insReporteSolicitud($scope.objetoReporte)
                          .then(function (response) {
                            reportesService.generarReportePDF(response.data.id);
  
                          }, function (error) {
                            toastr.error(error);
                          });  
                      }
                      else
                      {
                        toastr.warning("Faltan datos por ingresar y/o seleccionar");
                      }
                    }


                    $scope.grabarParametrosExcel = function (isValid) {
                      if (isValid)
                      {
                        $scope.objetoReporte = {};
                        $scope.objetoReporte.PARAMETROS = $scope.parametros;
                        $scope.objetoReporte.ID_REPORTE = $scope.reporte.ID_REPORTE;
                        $scope.objetoReporte.ID_USUARIO_REGISTRO = authService.getIdUsuario();
                        reportesService.insReporteSolicitud($scope.objetoReporte)
                          .then(function (response) {
                            reportesService.generarReporteExcel(response.data.id);
                          }, function (error) {
                            toastr.error(error);
                          });
                      }
                      else
                      {
                        toastr.warning("Faltan datos por ingresar y/o seleccionar");
                      }
                    }

                    $scope.grabarParametrosWord = function (isValid) {
                      if (isValid)
                      {
                        $scope.objetoReporte = {};
                        $scope.objetoReporte.PARAMETROS = $scope.parametros;
                        $scope.objetoReporte.ID_REPORTE = $scope.reporte.ID_REPORTE;
                        $scope.objetoReporte.ID_USUARIO_REGISTRO = authService.getIdUsuario();
                        reportesService.insReporteSolicitud($scope.objetoReporte)
                          .then(function (response) {
                            reportesService.generarReporteWord(response.data.id);
                          }, function (error) {
                            toastr.error(error);
                          });
                      }
                      else
                      {
                        toastr.warning("Faltan datos por ingresar y/o seleccionar");
                      }
                    }
                  }
                ]
              }
            }
          })
      }
    ]
  );
